/**
 * LENGTHS THE PAGE PUBLISHES ON ITS ROOT, WITH MORE THAN ONE AUTHOR (DK parity, S1d).
 *
 * Things fixed to the bottom of the screen have to know about each other: the
 * shop's floating help button rises above the cart bar, and Stylon's bar at the
 * end of the footer leaves room for both. So a fixed bar publishes its height as
 * a CSS length on `<html>` (`--sticky-cart-offset`, `--shop-dock-clearance`) and
 * the others read it with a `0px` fallback — which is also what every page reads
 * when nothing has been published.
 *
 * Two authors can hold the same length: the cart bar and the product page's
 * add-to-cart bar both hold the bottom of the screen. Each publishes under its
 * own key, the page reads the tallest, and one withdrawing never erases the
 * other's. A zero (a bar the stylesheet hides) is no bar at all.
 */
const published = new Map();

function apply(name) {
  if (typeof document === 'undefined' || !document.documentElement) return;
  const byKey = published.get(name);
  const tallest = byKey && byKey.size ? Math.max(...byKey.values()) : 0;
  if (tallest > 0) document.documentElement.style.setProperty(name, `${tallest}px`);
  else document.documentElement.style.removeProperty(name);
}

export function publishRootLength(name, key, px) {
  const value = Math.round(Number(px) || 0);
  if (!published.has(name)) published.set(name, new Map());
  if (value > 0) published.get(name).set(key, value);
  else published.get(name).delete(key);
  apply(name);
}

export function withdrawRootLength(name, key) {
  const byKey = published.get(name);
  if (byKey) byKey.delete(key);
  apply(name);
}
